import Concours from "@/pages/Concours";
export default function ProConcours() { return <Concours />; }
